"use client";

import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";

export default function ErrorPage({
  error,
}: {
  error: Error & { digest?: string };
}) {
  useEffect(() => {
    // You can integrate monitoring or logging here
    console.error(error);
  }, [error]);

  return (
    <main className="min-h-screen flex items-center justify-center px-6">
      <div className="text-center max-w-xl">
        <Image
          src="/logo.png"
          alt="VidMuse logo"
          width={80}
          height={80}
          className="mx-auto mb-6 h-20 opacity-90"
        />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Something went wrong
        </h1>
        {error?.message ? (
          <p className="text-gray-600 mb-4">{error.message}</p>
        ) : (
          <p className="text-gray-600 mb-4">
            Sorry, an unexpected error occurred.
          </p>
        )}
        <Link
          href="/"
          className="inline-flex items-center rounded-xl bg-[#5251F6] text-white px-4 py-2 hover:bg-indigo-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#5251F6]"
        >
          Back to Home
        </Link>
      </div>
    </main>
  );
}
